import Table from 'react-bootstrap/Table';
import Card from 'react-bootstrap/Card';
import React, {useEffect, useState} from "react";
import {FaSearch} from "react-icons/fa";
import axios from '../../utils/axios';
import Spinner from "react-bootstrap/Spinner";

function BusinessViews() {
    let [firstDate, setFirstDate] = useState(new Date());
    let [lastDate, setLastDate] = useState(new Date());
    const [views, setViews] = useState([]);
    const [filterViews, setFilterView] = useState([]);
    const [loader, setLoader] = useState(false);
    const [business, setBusiness] = useState({});
    let [payment, setPayment] = useState(0);

    const formatDate = (value) => {
        let day = value.getDate();
        let month = value.getMonth() + 1;
        const year = value.getFullYear();
        if (month < 10) {
            month = `0${month}`;
        }
        if (day < 10) {
            day = `0${day}`;
        }
        const finalDate = `${year}-${month}-${day}`;
        return finalDate;
    };
    const maxDate = formatDate(new Date());
    firstDate = formatDate(firstDate);
    lastDate = formatDate(lastDate);

    const viewDate = (viewDate) => {
        let newDate = new Date(viewDate);
        let day = newDate.getDate();
        let month = newDate.getMonth() + 1;
        const year = newDate.getFullYear();
        if (month < 10) {
            month = `0${month}`;
        }
        if (day < 10) {
            day = `0${day}`;
        }
        return `${month}-${day}-${year}`;
    };

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        let businessData = window.sessionStorage.getItem("business");
        businessData = JSON.parse(businessData);
        setBusiness(businessData);
        await fetchBusinessViews(businessData);
    }
    const onFilter = () => {
        let startDate = new Date(firstDate);
        startDate.setHours(0, 0, 0, 0);
        let endDate = new Date(lastDate);
        endDate.setHours(0, 0, 0, 0);
        let filteredData = views.filter((item) => {
            let itemDate = item.TimeStamp;
            itemDate = new Date(itemDate);
            itemDate.setHours(0, 0, 0, 0);
            if (itemDate >= startDate && itemDate <= endDate) {
                return true;
            }
            return false;
        });
        setFilterView(filteredData);
    }

    const fetchBusinessViews = async (businessData) => {
        setLoader(true);
        await axios.get('business/getBusinessViewFees/' + businessData._id).then((response) => {
            let responseViews = response.data.Data;
            responseViews = responseViews.reverse();
            setViews(responseViews);
            setFilterView(responseViews);
            setLoader(false);
        }).catch((error) => console.log(error));
    }

    return (
        <Card>
            <Card.Body>
                <div className='container'
                     style={{
                         padding: '20px',
                         marginBottom: '20px',
                         display: "flex",
                         borderRadius: '5px',
                         justifyContent: "space-between",
                         alignItems: "center",
                         backgroundColor: '#1A73E8',
                     }}
                >
                    <h6 style={{color: "white"}}>
                        Views Log
                    </h6>
                    <div className="d-flex justify-end">
                        <input
                            type="date"
                            min="2022-01-01"
                            max={maxDate}
                            className="form-control"
                            onChange={(event) => setFirstDate(new Date(event.target.value))}
                            value={firstDate}
                        />
                        <input
                            style={{marginLeft: '10px'}}
                            type="date"
                            min="2022-01-01"
                            max={maxDate}
                            className="form-control"
                            onChange={(event) => setLastDate(new Date(event.target.value))}
                            value={lastDate}
                        />
                        <button className={'btn btn-dark ms-2'} onClick={onFilter}>
                            <FaSearch/>
                        </button>
                    </div>
                </div>
                {loader ?
                    <div className="w-100 text-center">
                        <Spinner animation="border" role="status" variant='dark'>
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div>
                    : filterViews.length > 0 ?
                        <Table striped bordered>
                            <thead>
                            <tr style={{textAlign: 'center'}}>
                                <th style={{width: '35%'}}>Date</th>
                                <th style={{width: '35%'}}>Time</th>
                                <th style={{width: '30%'}}>Fee</th>
                            </tr>
                            </thead>
                            <tbody style={{textAlign: 'center'}}>
                            {filterViews.map((view) => {
                                payment = payment + view.BusinessViewFees;
                                let extraDate = viewDate(view.TimeStamp)
                                let date = new Date(view.TimeStamp);
                                let time = date.toLocaleTimeString();
                                return <>
                                    <tr>
                                        <td>{extraDate}</td>
                                        <td>{time}</td>
                                        <td>${view.BusinessViewFees}</td>
                                    </tr>
                                </>
                            })}
                            <tr>
                                <td><b>Total</b></td>
                                <td></td>
                                <td style={{color:'red'}}><b>${payment}</b></td>
                            </tr>
                            </tbody>
                        </Table>
                        :
                        <div className='text-center'><b>No logs found</b></div>
                }
            </Card.Body>
        </Card>
    );
}

export default BusinessViews;